import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Reset
	$("form[name='reset']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'reset[password]': {
				required: true,
			},
			'reset[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'reset[password]': {
				required: window.translations.required,
			},
			'reset[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
